import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {loadTrucks, saveTruck, deleteTruck, loadCollectionTypes} from '../../actions/truckActions';
import { Button, Collapse, Label, Input, FormGroup} from 'reactstrap';
import {find, some, remove} from 'lodash';
import Select from 'react-select';
import {toastr} from 'react-redux-toastr';
import {apiRequest} from '../../utils/request';
import TruckReceiptsGrid from './TruckReceiptsGrid';
import TruckLocationMap from './TruckLocationMap';
import moment from 'moment';
import {loadKioskSessions, unpairKiosk} from '../../actions/kioskActions';

class TrucksPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      trucks: props.trucks,
      selectedTruck: null,
      connections: [],
      kioskSessions: [],
    };

    this.loadConnections = this.loadConnections.bind(this);
    this.loadKioskSessions = this.loadKioskSessions.bind(this);
    this.handleUnpairKiosk = this.handleUnpairKiosk.bind(this);

    this.handleTruckFieldChange = this.handleTruckFieldChange.bind(this);
    this.handleCollectionTypeChange = this.handleCollectionTypeChange.bind(this);
    this.handleSaveTruck = this.handleSaveTruck.bind(this);
    this.handleDeleteTruck = this.handleDeleteTruck.bind(this);
  }

  handleTruckFieldChange(e) {
    let x = {...this.state.selectedTruck};

    if(e.target.type=="checkbox"){
      x[`${e.target.name}`] = e.target.checked;
    }
    else if(e.target.type=='number') {
      x[`${e.target.name}`] = e.target.value.replace(/\D/g,'');
    }
    else {
      x[`${e.target.name}`] = e.target.value;
    }

    this.setState({selectedTruck: x});
  }

  handleCollectionTypeChange(val) {
    this.setState({selectedTruck: {...this.state.selectedTruck, collectionTypeCodes: val}});
  }

  handleSaveTruck(){
    let {selectedTruck} = this.state;
    if(selectedTruck.name.trim() != '' && selectedTruck.numberPlate.trim() != '' && parseInt(selectedTruck.capacityLitres) >= 0){
      this.props.dispatch(saveTruck(this.state.selectedTruck));
      this.setState({selectedTruck: null});
    }
    else {
      toastr.error('Please enter valid values');
    }
  }

  handleDeleteTruck(){
    if(confirm('Are you sure about deleting this truck?')){
      this.props.dispatch(deleteTruck(this.state.selectedTruck));
      this.setState({selectedTruck: null});
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(JSON.stringify(prevProps.trucks) !== JSON.stringify(this.props.trucks)){
      this.setState({trucks: this.props.trucks});
    }
  }

  componentDidMount(){
    this.props.dispatch(loadTrucks(true));
    this.props.dispatch(loadCollectionTypes());
    this.loadConnections();
    this.loadKioskSessions();
    this.connectionsTimer = setInterval(() => {
      this.loadConnections();
      this.loadKioskSessions();
    }, 15000);
  }

  componentWillUnmount(){
    if(this.connectionsTimer){
      clearInterval(this.connectionsTimer);
    }
  }

  loadConnections(){
    apiRequest('/api/trucks/connections').then(res => {
      if(res && res.data && Array.isArray(res.data)){
        this.setState({connections: res.data});
      }
    });
  }

  loadKioskSessions(){
    this.props.dispatch(loadKioskSessions()).then(res => {
      if(res && res.data && Array.isArray(res.data)){
        this.setState({kioskSessions: res.data});
      }
    });
  }

  // Who is signed in at this truck's cabinet console, if anyone.
  getKioskSession(numberPlate){
    if(!numberPlate){
      return null;
    }
    return this.state.kioskSessions.find(k => k.truckNumberPlate
      && k.truckNumberPlate.toLowerCase() === numberPlate.toLowerCase()) || null;
  }

  // Force-unpair. For a console someone walked away from without signing out — the token is a
  // self-contained JWT, so this revocation is the only thing that stops it working.
  handleUnpairKiosk(session){
    if(!confirm(`Sign ${session.driverName || 'the driver'} out of the console on ${session.truckNumberPlate}?`)){
      return;
    }

    this.props.dispatch(unpairKiosk(session.truckNumberPlate)).then(res => {
      if(res && res.data && res.data.success){
        toastr.success('Console signed out', `${session.truckNumberPlate} is no longer paired.`);
      } else {
        toastr.error('Sign out failed', 'Could not sign the console out.');
      }
      this.loadKioskSessions();
    });
  }

  isTruckConnected(numberPlate){
    if(!numberPlate){
      return false;
    }
    const match = this.state.connections.find(c => c.truckNumberPlate && c.truckNumberPlate.toLowerCase() === numberPlate.toLowerCase());
    return !!(match && match.connected);
  }

  render(){
    return (<div>
      <Collapse isOpen={!this.state.selectedTruck}>
        <div className="row">
          <div className="col-md-12">
            <h4>Manage Trucks&nbsp;<Button color="success" onClick={() => this.setState({selectedTruck: {
              id: -1,
              name:'',
              numberPlate: '',
              certNo: '',
              capacityLitres:0,
              isInactive: false,
              isWeightCapable: false,
              isReceiptCapable: false,
              autoCompleteOnReceipt: false,
              collectionTypeCodes: ''}})}><i className="fa fa-plus" /> Add truck</Button></h4>
            <table className="table">
              <thead>
              <tr>
                <th>Name</th>
                <th>Plate</th>
                <th>Cert No.</th>
                <th>Capacity</th>
                <th>Types</th>
                <th>Weight</th>
                <th>Receipt</th>
                <th>Auto-complete</th>
                <th>Active</th>
                <th>Truck-Proxy</th>
                <th>Console</th>
              </tr>
              </thead>
              <tbody>
              {this.state.trucks.items.length==0 && <tr><td>There are no trucks</td><td>&nbsp;</td></tr>}
              {this.state.trucks.items.map(x => {
                const connected = this.isTruckConnected(x.numberPlate);
                const kiosk = this.getKioskSession(x.numberPlate);
                return (<tr key={x.id}>
                  <td><a href="#" onClick={(e) => {
                    e.preventDefault();
                    this.setState({selectedTruck: x});
                  }}>{x.name}</a></td>
                  <td>{x.numberPlate}</td>
                  <td>{x.certNo}</td>
                  <td>{x.capacityLitres}</td>
                  <td>{x.collectionTypeCodes}</td>
                  <td><i className={x.isWeightCapable ? 'fa fa-check': 'fa fa-times'} /></td>
                  <td><i className={x.isReceiptCapable ? 'fa fa-check': 'fa fa-times'} /></td>
                  <td><i className={x.autoCompleteOnReceipt ? 'fa fa-check': 'fa fa-times'} /></td>
                  <td><i className={x.isInactive ? 'fa fa-times': 'fa fa-check'} /></td>
                  <td title={x.numberPlate || ''}>
                    <i className={connected ? 'fa fa-circle text-success' : 'fa fa-circle text-muted'} />
                    &nbsp;{connected ? 'Online' : 'Offline'}
                  </td>
                  <td>
                    {kiosk ? (<span>
                      <i className="fa fa-circle text-success" />
                      &nbsp;{kiosk.driverName || 'Signed in'}
                      &nbsp;<small className="text-muted">since {moment(kiosk.pairedAt).format('HH:mm')}</small>
                      {kiosk.runId ? <small className="text-muted">&nbsp;(run {kiosk.runId})</small> : null}
                      &nbsp;<a href="#" onClick={(e) => {
                        e.preventDefault();
                        this.handleUnpairKiosk(kiosk);
                      }}>sign out</a>
                    </span>) : (<span className="text-muted">
                      <i className="fa fa-circle text-muted" />&nbsp;Not signed in
                    </span>)}
                  </td>
                </tr>);
              })}
              </tbody>
            </table>
          </div>
        </div>
      </Collapse>

      {this.state.selectedTruck && <div className="container">
        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="col-md-12">
            <h4>{ this.state.selectedTruck.id > 0 ? 'Edit Truck' : 'Create Truck'}&nbsp;<a href="#" className="text-muted"  onClick={(e)=> {
              e.preventDefault();
              this.setState({selectedTruck: null});
            }}>done</a></h4>
          </div>
        </div>
        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="col-md-12">
            {this.state.selectedTruck.canDelete && <Button color="danger" onClick={this.handleDeleteTruck}><i className="fa fa-trash" />&nbsp;Delete Truck</Button>}
            {!this.state.selectedTruck.canDelete && this.state.selectedTruck.id > 0 && <span>This truck can't be deleted as it is assigned to a run</span>}
            </div>
        </div>
        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-horizontal">
              <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="name">Truck name</label>
                <div className="col-md-8">
                  <Input type="text"
                         value={this.state.selectedTruck.name}
                         onChange={this.handleTruckFieldChange}
                         name="name"
                         placeholder="Truck name"
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="numberPlate">Number plate</label>
                <div className="col-md-8">
                  <Input type="text"
                         value={this.state.selectedTruck.numberPlate}
                         onChange={this.handleTruckFieldChange}
                         name="numberPlate"
                         placeholder="Number plate"
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="certNo">Cert No.</label>
                <div className="col-md-8">
                  <Input type="text"
                         value={this.state.selectedTruck.certNo || ''}
                         onChange={this.handleTruckFieldChange}
                         name="certNo"
                         placeholder="Certification number"
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="capacityLitres">Capacity litres</label>
                <div className="col-md-8">
                  <Input type="number"
                         value={this.state.selectedTruck.capacityLitres}
                         onChange={this.handleTruckFieldChange}
                         name="capacityLitres"
                         placeholder="Capacity litres"
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="collectionType">Collection types</label>
                <div className="col-md-8">
                  <Select
                    name="collectionType"
                    value={this.state.selectedTruck.collectionTypeCodes}
                    multi
                    simpleValue
                    options={this.state.trucks.collectionTypes}
                    onChange={this.handleCollectionTypeChange}
                    delimiter=", "
                  />

                </div>
              </div>
              <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="isActive">Is active</label>
                <div className="col-md-6">
                  <FormGroup check>
                    <Label check>

                      <Input type="checkbox"
                             onChange={(e)=> this.setState({selectedTruck: {...this.state.selectedTruck, isInactive: !e.target.checked}})}
                             checked={!this.state.selectedTruck.isInactive}
                             name="isInactive"
                      />
                    </Label>
                  </FormGroup>
                </div>

              </div>
              <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="isWeightCapable">Weight capable</label>
                <div className="col-md-6">
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox"
                             onChange={this.handleTruckFieldChange}
                             checked={!!this.state.selectedTruck.isWeightCapable}
                             name="isWeightCapable"
                      />
                    </Label>
                  </FormGroup>
                </div>
              </div>
              <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="isReceiptCapable">Receipt capable</label>
                <div className="col-md-6">
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox"
                             onChange={this.handleTruckFieldChange}
                             checked={!!this.state.selectedTruck.isReceiptCapable}
                             name="isReceiptCapable"
                      />
                    </Label>
                  </FormGroup>
                </div>
              </div>
              <div className="form-group row">
                <label className="col-md-2 form-control-label"  htmlFor="autoCompleteOnReceipt">Auto-complete on receipt</label>
                <div className="col-md-6">
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox"
                             onChange={this.handleTruckFieldChange}
                             checked={!!this.state.selectedTruck.autoCompleteOnReceipt}
                             name="autoCompleteOnReceipt"
                      />
                    </Label>
                  </FormGroup>
                </div>
              </div>
              <div className="form-group row">
                <div className="offset-md-2 col-md-8">
                  <Button color="primary" onClick={this.handleSaveTruck}><i className="fa fa-save" />&nbsp;</Button>&nbsp;
                  <Button color="seconday" onClick={()=> this.setState({selectedTruck: null})}><i className="fa fa-mail-reply" />&nbsp;</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.selectedTruck.id > 0 && this.state.selectedTruck.numberPlate && <div className="row">
          <div className="col-md-12">
            <hr />
            <h5>Live Location</h5>
            <TruckLocationMap numberPlate={this.state.selectedTruck.numberPlate} />
          </div>
        </div> }
        {this.state.selectedTruck.id > 0 && this.state.selectedTruck.numberPlate && <div className="row">
          <div className="col-md-12">
            <hr />
            <h5>Received Receipts</h5>
            <TruckReceiptsGrid numberPlate={this.state.selectedTruck.numberPlate} />
          </div>
        </div> }
      </div> }
    </div>);
  }
}

TrucksPage.propTypes = {

};

function mapStateToProps(state){
  return {
    trucks: state.trucks,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TrucksPage);
